import { atom } from 'jotai'
import type { Locale } from '@/i18n/i18n-config';

type lng = {
    lng: Locale;
};
export const lngState = atom<lng>({
    lng: 'en',
});
